import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Typography, useMediaQuery } from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import certificate from "../../../assets/prtp/Research_rider_Certificate-min.png";
import Image from "next/image";

const PRTPAchiev = () => {
  React.useEffect(() => {
    AOS.init();
  }, []);

  const fontQue = useMediaQuery("(max-width:768px)");
  return (
    <Container className="my-5">
      <Row
        className="justify-content-center align-items-center g-2"
        // style={{ backgroundColor: "#64acb8" }}
      >
        <Col
          md={6}
          xs={12}
          data-aos="zoom-in"
          className="d-flex justify-content-center"
        >
          <Image
            className="border rounded-4"
            height={580}
            width={420}
            src={certificate}
            alt="research ride certificate"
          />
        </Col>
        <Col
          md={6}
          xs={12}
          className="text-black pb-3"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <Typography
            className="m-0"
            align="center"
            fontWeight={600}
            variant={fontQue ? "h4" : "h2"}
            gutterBottom
          >
            <span className="text-warning">A</span>chievement
          </Typography>
          <Typography align="center" fontWeight={600} variant="h6" gutterBottom>
            from <span className="text-primary">PRTP</span>
          </Typography>
          <Typography
            sx={{ mt: 2, fontWeight: "600" }}
            align="center"
            variant="subtitle2"
            gutterBottom
          >
            After the completion of PRTP a student can receive a certificate
            signed by honorable PRTP teachers.
          </Typography>
        </Col>
      </Row>
    </Container>
  );
};

export default PRTPAchiev;
